import { addToast, closeAll } from "@heroui/toast";
import {
    LuInfo,
    LuCircleCheck,
    LuCircleAlert,
    LuCircleX,
} from "react-icons/lu";

export const showToast = (type, title, message) => {
    const icons = {
        success: (
            <div className="flex items-center justify-center">
                <LuCircleCheck
                    size={20}
                    className="text-emerald-600 dark:text-emerald-400"
                />
            </div>
        ),
        warning: (
            <div className="flex items-center justify-center">
                <LuCircleAlert
                    size={20}
                    className="text-amber-600 dark:text-amber-400"
                />
            </div>
        ),
        error: (
            <div className="flex items-center justify-center">
                <LuCircleX
                    siz={20}
                    className="text-rose-600 dark:text-rose-400"
                />
            </div>
        ),
        info: (
            <div className="flex items-center justify-center">
                <LuInfo
                    size={20}
                    className="text-blue-600 dark:text-blue-400"
                />
            </div>
        ),
    };

    // Semantic colors for subtle accents
    const accentColors = {
        success: "border-l-emerald-500",
        error: "border-l-rose-500",
        info: "border-l-blue-500",
        warning: "border-l-amber-500",
    };

    addToast({
        title: title,
        description: message,
        icon: icons[type],
        radius: "lg",
        shadow: "sm",
        classNames: {
            base: `
                bg-white dark:bg-zinc-900 
                border border-zinc-200 dark:border-zinc-800 
                border-l-4 ${accentColors[type]}
                shadow-md 
                rounded-r-xl rounded-l-md
                p-4 
                data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full
            `,
            title: "text-zinc-900 dark:text-zinc-50 font-semibold text-sm",
            description: "text-zinc-500 dark:text-zinc-400 text-xs mt-0.5",
            closeButton:
                "opacity-0 group-hover:opacity-100 absolute top-2 right-2 transition-opacity text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300",
        },
        timeout: type === "error" ? 0 : 5000,
        shouldShowCloseButton: true,
    });
};

export const clearToast = () => closeAll();
